import React, { useState, useEffect } from 'react';
import DropZone from '../components/DropZone/DropZone';
import LocationSelector from '../components/LocationSelector/LocationSelector';
import Title from '../components/Title/Title'
import UploadForm from '../components/UploadForm/UploadForm';
import { ItemTypes } from '../Types/TrashTypes';
import Modal from '../components/Modal/Modal'
import './Home.css';

function Home({ selectedCity, setSelectedCity, isSound, setIsSound }) {
    const [selectedImg, setSelectedImg] = useState(null);

    function createRecycleBins(city) {
        if (ItemTypes[city]) {
            setSelectedCity(city)
            return Object.keys(ItemTypes[city]).map((key) => ItemTypes[city][key]);
        }
        return []
    }


    return (
        <div className="home">
            <div className="title-container">
                <Title /></div>
            <div className="menu">
                <LocationSelector setSelectedCity={(city) => setSelectedCity(city)} selectedCity={selectedCity} isSound={isSound}/>
                <UploadForm isSound={isSound} />
            </div>
            <div className="content">
                <DropZone recycleBins={createRecycleBins(selectedCity)} type={'any'} setSelectedImg={setSelectedImg} isSound={isSound} setIsSound={(e)=>setIsSound(e)}/>
            </div>
            <div className="modal">
                {selectedImg && <Modal selectedImg={selectedImg} setSelectedImg={setSelectedImg} isSound={isSound}/>}
            </div>
        </div>
    )
}

export default Home